import { custom } from 'devextreme/ui/dialog'
import axios from 'axios'

export interface ConditionalConfirmApiOptions {
	apiBaseUrl: string
	folder: string
	model: string
	onSuccess?: (data: any) => void
	onError?: (msg: string) => void
}

export function getConditionalConfirm(
	changes: Array<{ type: string; key?: any; data?: any }>,
	keyField: string,
	config: Array<{ field: string; value: string; title: string; message: string }>
): { title: string; message: string; row: Record<string, any> } | null {
	if (!changes?.length || !config?.length) return null
	for (const change of changes) {
		if (change.type !== 'update' && change.type !== 'insert') continue
		const k = change.key
		const keyObj = k != null && typeof k === 'object' && !Array.isArray(k) ? k : keyField ? { [keyField]: k } : {}
		const row = { ...keyObj, ...(change.data ?? {}) }
		const match = config.find(c => row[c.field] != null && String(row[c.field]) === String(c.value))
		if (match) return { title: match.title, message: match.message, row }
	}
	return null
}

export async function showConditionalConfirmWithApi(
	title: string,
	message: string,
	row: Record<string, any>,
	opts: ConditionalConfirmApiOptions
): Promise<boolean> {
	const res = await custom({
		title,
		messageHtml: message,
		buttons: [
			{ text: 'Yes', onClick: () => ({ clicked: true }) },
			{ text: 'No', onClick: () => ({ clicked: false }) },
		],
	})
		.show()
		.catch(() => ({ clicked: false }))
	if (res?.clicked !== true) return false
	try {
		const { data } = await axios.post(`${opts.apiBaseUrl}/view/conditionalConfirm`, {
			folder: opts.folder,
			model: opts.model,
			row,
		})
		opts.onSuccess?.(data)
		return true
	} catch (e: any) {
		opts.onError?.(e?.response?.data?.message ?? e?.message ?? 'Request failed')
		return false
	}
}

export async function showInsertWithPrecheck(
	title: string,
	message: string,
	row: Record<string, any>,
	opts: ConditionalConfirmApiOptions
): Promise<boolean | 'done'> {
	let needsConfirm = true
	try {
		const { data } = await axios.post(`${opts.apiBaseUrl}/view/insertPrecheck`, {
			folder: opts.folder,
			model: opts.model,
			row,
		})
		needsConfirm = data?.confirm !== false
	} catch (e: any) {
		opts.onError?.(e?.response?.data?.message ?? e?.message ?? 'Request failed')
		return false
	}

	if (!needsConfirm) return true

	const res = await custom({
		title,
		messageHtml: message,
		buttons: [
			{ text: 'Yes', onClick: () => ({ clicked: true }) },
			{ text: 'No', onClick: () => ({ clicked: false }) },
		],
	})
		.show()
		.catch(() => ({ clicked: false }))
	if (res?.clicked !== true) return false

	try {
		const { data } = await axios.post(`${opts.apiBaseUrl}/view/insertConfirm`, {
			folder: opts.folder,
			model: opts.model,
			row,
		})
		return data?.handled ? 'done' : true
	} catch (e: any) {
		opts.onError?.(e?.response?.data?.message ?? e?.message ?? 'Request failed')
		return false
	}
}

export const conditionalConfirmDialog = null
